<template>
  <page layoutClass="analytics-referral-requests" :loading="$apollo.loading">
    <b-row class="title">
      <b-col cols="12">
        <h2>Referral Activity</h2>
        <p class="mb-5">
          All referrals, either requested by you and other recruiters, or suggested by your employees.<br/>
          If a candidate is interested in a role shared by an employee, <strong>they still need to apply</strong>.
        </p>
        <div v-if="referrals">
          <ag-grid-vue
            class="ag-theme-balham"
            :columnDefs="fields"
            :rowData="referrals" style="height: 600px;"
            :floatingFilter="true"
            @gridReady="onGridReady"
            :pagination="true"/>
          <b-btn variant="outline-primary" @click="downloadToCSV">Download to CSV</b-btn>
        </div>
      </b-col>
    </b-row>
    <template v-if="selectedProfile">
      <contact-profile-modal id="analytics-referral-requests-contact-profile" :contact="selectedProfile" />
    </template>
  </page>
</template>

<script>
import formatDate from 'date-fns/format';
import Page from '@/components/Page';
import ContactProfileModal from '@/modals/contact-profile';
import ReferralsRecruiterRequestsQuery from '@/graphql/queries/ReferralsRecruiterRequests.gql';
import { AgGridVue } from 'ag-grid-vue';

export default {
  components: {
    Page,
    AgGridVue,
    ContactProfileModal
  },
  data: () => ({
    err: null,
    // fields: fields,
    gridAPI: null,
    selectedProfile: null,
  }),
  apollo: {
    referralConnections: {
      query: ReferralsRecruiterRequestsQuery,
      // variables: { page: 1, limit: 12 },
      update(data) {
        const { company } = data || {};
        const { referralConnections } = company || {};
        return referralConnections;
      },
      error(err) {
        this.err = `${err}`;
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    fields() {
      const self = this;
      return [
        {
          headerName: '',
          field: 'contact.avatar',
          width: 50,
          cellRenderer(params) {
            return `<img src="/static/images/avatars/main${params.value || 1}.png" class="row-avatar"/>`;
          },
        },
        {
          headerName: '',
          field: 'contact.id',
          width: 60,
          cellRenderer(params) {
            const eDiv = document.createElement('div');
            eDiv.innerHTML = '<span class="open-modal"><a href="#">Profile</a></span>';
            const eButton = eDiv.querySelectorAll('.open-modal')[0];

            eButton.addEventListener('click', () => {
              self.openModal(params);
            });

            return eDiv;
          },
        },
        {
          headerName: 'Current Role',
          field: 'contact.latestEmployment.title',
          width: 400,
          sortable: true,
          filter: 'agTextColumnFilter',
          valueGetter({ data: { contact } }) {
            const { latestEmployment } = contact || {};
            return latestEmployment && latestEmployment.title ? latestEmployment.title : '(Not Known)';
          },
        },
        {
          headerName: 'Current Company',
          field: 'contact.latestEmployment.companyName',
          sortable: true,
          filter: 'agTextColumnFilter',
          valueGetter({ data: { contact } }) {
            const { latestEmployment } = contact || {};
            return latestEmployment && latestEmployment.companyName ? latestEmployment.companyName : '(Not Known)';
          },
        },
        {
          headerName: 'Referred Job',
          field: 'job.title',
          sortable: true,
          width: 300,
          filter: 'agTextColumnFilter',
          cellRenderer(params) {
            return `<a href="/jobs/${params.data.job.id}" target="_blank"><b>${params.value}</b></a>`;
          },
        },

        {
          headerName: 'Status',
          field: 'status',
          sortable: true,
          filter: 'agTextColumnFilter',
          valueGetter({ data: { status } }) {
            switch (status) {
              case 'SUGGESTED': return 'Sent to candidate';
              case 'REQUESTED': return 'Requested by recruiter';
              case 'ACCEPTED': return 'Sent to candidate';
              case 'DECLINED': return 'Declined by referee';
              default: return status;
            }
          },
        },
        {
          headerName: 'Referee',
          field: 'user.fullName',
          sortable: true,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Recruiter',
          field: 'recruiter.fullName',
          sortable: true,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Created',
          field: 'created',
          sortable: true,
          valueGetter({ data: { created } }) {
            return formatDate(created, 'YYYY-MM-DD HH:mm:ss');
          },
        },
        {
          headerName: 'Updated',
          field: 'updated',
          sortable: true,
          valueGetter({ data: { updated } }) {
            return formatDate(updated, 'YYYY-MM-DD HH:mm:ss');
          },
        },
      ];
    },
    referrals() {
      if (this.referralConnections && Array.isArray(this.referralConnections.edges)) {
        return this.referralConnections.edges.reduce((referrals, edge) => {
          if (edge && edge.entry && edge.entry.status !== 'IN_PROGRESS') {
            referrals.push(edge.entry);
          }
          return referrals;
        }, []);
      } else {
        return [];
      }
    }
  },
  metaInfo() {
    const title = 'Referral Requests';
    return { title };
  },
  methods: {
    onGridReady(params) {
      this.gridAPI = params.api;
    },
    downloadToCSV() {
      this.gridAPI.exportDataAsCsv();
    },
    openModal(params) {

      this.selectedProfile = params.data.contact;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'analytics-referral-requests-contact-profile'));
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/analytics/analyticsReferralRequests.vue